/// <reference path="../../vendor/angular/angular.js" />
'use strict';

angular.module('itPurchasingControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'directives.IAMContact',
    'directives.userRequestFollowups',
    'services.ITPurchasing',
    'services.userAccessRequest']);